export default "__VITE_ASSET__DebUb1vu__"